import React, { useState } from "react";
import Layout from "Containers/layout";
import Head from "next/head";
import cookie from "cookie";
import { END } from "redux-saga";
import Env from "Consts/env";
import { loadSelf } from "@fdn/profile_store";
import Vars from "Consts/vars";
import InstructionTicket from "Components/instruction_ticket/instructionTicket";
// import MapTicket from "Components/map_ticket/MapTicket";
import HowToClaimTicket from "Components/how_to_claim_ticket/HowToClaimTicket";
import TermsAndConditionsTicket from "Components/terms_and_conditions_ticket/TermsAndConditionsTicket";
import BannerTicket from "Components/banner_ticket/BannerTicket";
import { wrapper } from "../store/index";

const Index = (props) => {

	const { isMobile, getStoreSelf, query } = props;

	const [activeAccordions, setActiveAccordions] = useState([]);

	const toggleAccordion = (id) => {

		if (activeAccordions.includes(id)) {

			const tempAccordions = activeAccordions.filter((item) => item !== id);
			setActiveAccordions(tempAccordions);

		} else {

			setActiveAccordions((current) => [...current, id]);

		}

	};

	const handleClaimTicket = () => {

		if (typeof window !== "undefined") {

			window.location.href = `com.femaledaily.fdbr://femaledaily.${process.env.NEXT_PUBLIC_NODE_ENV === "production" ? "com" : "net"}${process.env.NEXT_PUBLIC_PREFIX}/scanqr?code=${query.code}`;

		}

	};

	return (
		<Layout
			isMobile={isMobile}
			title="Female Daily Ticketing | Redeem Instruction"
			self={getStoreSelf}
		>
			<Head>
				<meta property="og:image" content={process.env.NEXT_PUBLIC_BANNER_DESKTOP} />
			</Head>

			<BannerTicket
				isMobile={isMobile}
				bannerUrl={process.env.NEXT_PUBLIC_BANNER_DESKTOP}
				bannerUrlMob={process.env.NEXT_PUBLIC_BANNER_MOBILE}
				marginBottom={isMobile ? "24px" : "80px"}
			/>

			<InstructionTicket
				isMobile={isMobile}
				isShowClaimTicket={query?.code?.length}
				handleClaimTicket={handleClaimTicket}
			/>

			{/* <MapTicket
				isMobile={isMobile}
				imageUrl="https://image.femaledaily.com/mxb2022/venue.png"
				mapUrl="https://drive.google.com/file/d/13SqsVSTPPT2YjHAYQkgE0-OTV9qism0L/view"
				marginTop={!isMobile && "35px"}
				marginBottom={!isMobile && "50px"}
			/> */}

			<div className="container">
				{/* <HowToClaimTicket
					isMobile={isMobile}
					firstTitle="Cara Klaim Tiket Via"
					secondTitle="Kode Voucher Lazada"
					subtitle="Pastikan kamu sudah memiliki akun Female Daily serta sudah mendownload dan telah terhubung dengan aplikasi."
					instructionCard={Vars.INSTRUCTION_LAZADA}
					accordionId="acc-0"
					isAccordionActive={activeAccordions.includes("acc-0")}
					toggleAccordion={toggleAccordion}
					marginBottom={isMobile ? "0px" : "72px"}
				/> */}
				<HowToClaimTicket
					isMobile={isMobile}
					firstTitle="Cara klaim tiket yang dibeli di"
					secondTitle="Livin' Sukha by Mandiri"
					col={4}
					subtitle="Pastikan kamu sudah memiliki aplikasi Female Daily dan login."
					instructionCard={Vars.MANDIRI_HAVE_ACC}
					accordionId="acc-1"
					isAccordionActive={activeAccordions.includes("acc-1")}
					toggleAccordion={toggleAccordion}
					marginBottom={isMobile ? "0px" : "72px"}
				/>

				<HowToClaimTicket
					isMobile={isMobile}
					firstTitle="Bila Belum Memiliki Aplikasi "
					secondTitle="Female Daily"
					subtitle="Pastikan kamu sudah memiliki tiket yang dibeli di Livin' Sukha by Mandiri."
					instructionCard={Vars.MANDIRI_NO_ACC}
					accordionId="acc-2"
					isAccordionActive={activeAccordions.includes("acc-2")}
					toggleAccordion={toggleAccordion}
					marginBottom={isMobile ? "0px" : "72px"}
				/>

				<HowToClaimTicket
					isMobile={isMobile}
					firstTitle="Cara Klaim Tiket Melalui"
					secondTitle="Aplikasi"
					col={4}
					subtitle="Pastikan kamu login menggunakan akun yang sama dengan yang kamu gunakan ketika membeli tiket di Female Daily Studio."
					instructionCard={Vars.INSTRUCTIONS_APP}
					accordionId="acc-3"
					isAccordionActive={activeAccordions.includes("acc-3")}
					toggleAccordion={toggleAccordion}
					marginBottom={isMobile ? "0px" : "72px"}
				/>

				<HowToClaimTicket
					isMobile={isMobile}
					firstTitle="Cara Klaim Tiket Via"
					secondTitle="Link Tiket"
					subtitle="Pastikan kamu sudah memiliki akun Female Daily serta sudah mendownload dan telah terhubung dengan aplikasi"
					instructionCard={Vars.INSTRUCTIONS_TICKET}
					accordionId="acc-4"
					isAccordionActive={activeAccordions.includes("acc-4")}
					toggleAccordion={toggleAccordion}
					marginBottom={isMobile ? "0px" : "72px"}
				/>

				<HowToClaimTicket
					isMobile={isMobile}
					firstTitle="Cara"
					secondTitle="Share Tiket"
					col={4}
					subtitle="Pastikan kamu login menggunakan akun yang sama dengan yang kamu gunakan ketika membeli tiket di Female Daily Studio."
					instructionCard={Vars.INSTRUCTIONS_SHARE}
					accordionId="acc-5"
					isAccordionActive={activeAccordions.includes("acc-5")}
					toggleAccordion={toggleAccordion}
					marginBottom={isMobile ? "0px" : "72px"}
				/>
				{
					!isMobile && (<hr className="border-line" />)
				}
			</div>

			<TermsAndConditionsTicket
				isMobile={isMobile}
				marginTop={isMobile ? "40px" : "106px"}
				marginBottom={isMobile ? "34px" : "260px"}
			/>

			<style>
				{`
					.instruction-card-content {
						max-width: 210px;
						margin: auto;
					}

					.how-to-claim-title span {
						color: var(--fd-red-6);
					}

					.border-line {
						border: 1px solid #F0F3F7;
					}
				`}
			</style>

		</Layout>
	);

};

export const getServerSideProps = wrapper.getServerSideProps(
	async ({
		store,
		req,
		query,
		res,
	}) => {

		let userAgent;
		let cookies;
		let authorization = null;

		if (req) {

			// if you are on the server and you get a "req" property from your context
			userAgent = req.headers["user-agent"]; // get the user-agent from the headers

		} else {

			// if you are on the client you can access the navigator from the window object
			userAgent = navigator.userAgent;

		}

		const isMobile = Boolean(
			userAgent.match(
				/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i,
			),
		);

		const isServer = !!req;

		if (req.headers.cookie) {

			cookies = cookie.parse(req.headers.cookie);
			authorization = cookies.token;

		}

		if (authorization) {

			await store.dispatch(
				loadSelf({
					payload: {
						api_env: process.env.NEXT_PUBLIC_NODE_ENV,
						env: Env.HEADERS,
						Authorization: authorization,
						is_server: isServer,
						is_allo: process.env.NEXT_PUBLIC_ALLO_STATUS === "ON",
						res,
					},
				}),
			);

		}

		store.dispatch(END);
		await store.sagaTask.toPromise();

		let getStoreSelf = {};
		if (authorization) {

			getStoreSelf = !!store.getState().storeSelf.data === true ? store.getState().storeSelf : [];

		}

		return {
			props: {
				query,
				isMobile,
				getStoreSelf,
			}, // will be passed to the page component as props
		};

	},
);

export default Index;
